// extracted by mini-css-extract-plugin
module.exports = {"briefSection":"__4-brief_briefSection__x6d67","briefLink":"__4-brief_briefLink__Er1la","skeletonWrap":"__4-brief_skeletonWrap__oOL8O"};